<template>
    <section class="section_padding">
        <div class="container">
            <div class="p20 itinerary-content mb20">
                <div class="row mb20">
                    <div class="col-md-6 text-left">
                        <h3 class="prime-color">
                            {{ title }}
                        </h3>
                        <span>{{ date }}</span>
                    </div>
                    <div class="col-md-6 text-right"></div>
                </div>
                <div class="row mb20">
                    <div v-for="item in fareRules" :key="item.descriptionType" class="col-md-12 mb10">
                        <span class="second-color bold">
                            {{ item.descriptionType }}
                        </span>
                        <p class="pre-inline">
                            {{ item.text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { convertDate } from '@/utils/dateUtils';
export default {
    name: 'FlightDetailsArea',
    data: () => ({
        title: null,
        date: null,
        fareRules: [],
    }),
    mounted() {
        var segments_ids = [];
        var searchData = JSON.parse(localStorage.getItem("searchData"));
        var detailedFareRules = JSON.parse(localStorage.getItem('detailed_fare_rules'));
        var departure_flight = JSON.parse(localStorage.getItem('departure_flight'));
        var arrival_flight = JSON.parse(localStorage.getItem('arrival_flight'));

        if (this.$route.params.id == 1) {
            departure_flight.itineraries[0].segments.forEach((element) => {
                segments_ids.push(element.id);
            });
            this.title = `${searchData['from']} - ${searchData['to']}`;
            this.date = convertDate(searchData['date']);
        } else if (this.$route.params.id == 2) {
            arrival_flight.itineraries[1].segments.forEach((element) => {
                segments_ids.push(element.id);
            });
            this.title = `${searchData['to']} - ${searchData['from']}`;
            this.date = convertDate(searchData['ret_date']);
        } else {
            departure_flight.itineraries.forEach((element) => {
                element.segments.forEach((element) => {
                    segments_ids.push(element.id);
                });
            });
            this.title =
                `${departure_flight.itineraries[0].segments[0].departure.iataCode} - ${departure_flight.itineraries[0].segments[0].arrival.iataCode}`;
            this.date = convertDate(departure_flight.itineraries[0].segments[0].departure.at);
        }
        Object.values(detailedFareRules).forEach((value, key) => {
            if (segments_ids.includes(value['segmentId'])) {
                this.fareRules = value['fareNotes']['descriptions'];
            }
        });
    }
}
</script>
<style scoped>
.itinerary-content {
    background-color: var(--theme-search-form-bg);
    border-radius: 6px;
}

.section_padding {
    padding: 50px 0;
}

.p20 {
    padding: 20px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.prime-color {
    color: var(--main-color);
}

.second-color {
    color: var(--main-color);
}

.pre-inline {
    white-space: pre-line;
}

.bold {
    font-weight: 600;
    font-style: normal;
}
</style>